import React from 'react';
import { Menu } from '@mui/material';

function RecipeBuilderGridControlsMenu(props) {
  return (
    <Menu
      className="recipe-builder-grid-controls-menu"
      keepMounted
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: -6,
        horizontal: 'right',
      }}
      {...props}
    />
  );
}

export default RecipeBuilderGridControlsMenu;
